import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function PotatoLentilSoup() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Potato Lentil Soup</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 tsp (10 mL) vegetable
        oil<br></br>1 medium onion, diced<br></br>4 cups (960 mL) water<br></br>
        1 vegetable bouillon cube, crushed<br></br>1 cup (192 g) dry red
        lentils, rinsed<br></br>1 medium potato, diced into 1 cm cubes<br></br>1
        Tbsp (7 g) paprika powder<br></br>2 tsp (5 g) onion powder<br></br>2 tsp
        (6 g) garlic powder<br></br>2 tsp (10 mL) balsamic vinegar<br></br>⅛ tsp
        ground black pepper, or more to taste<br></br>1 pinch salt, or more to
        taste<br></br>
      </Typography>

      <Typography>
        To a large pot on medium-high heat, add the oil. When hot, add the onion
        and sauté until golden, about 5 minutes.<br></br>
        <br></br>
        Add in the remaining ingredients. Bring to a boil and then reduce to a
        simmer. <br></br>
        Partially cover with a lid and cook for 15 minutes, or until the lentils
        and potato are cooked through.<br></br>
        <br></br>
        Taste test, adding more salt and pepper if desired and add more water
        depending on how you like the consistency of your soup.<br></br>
        <br></br>
        Serve with yogurt, bread, and any other desired toppings. Enjoy!
        <br></br>
      </Typography>
    </Card>
  );
}
